// Endpoint.tsx

import React from 'react';
import axios from 'axios';

// Définir une interface pour les props
interface EndpointProps {
  name: string;
  description: string;
  url: string;
  parameters: { name: string; type: string; description: string }[];
  exampleRequest: any; // Adapter selon votre structure de données
  exampleResponseSuccess: any; // Adapter selon votre structure de données
  exampleResponseError: any; // Adapter selon votre structure de données
}

const Endpoint: React.FC<EndpointProps> = ({ 
  name, 
  description, 
  url, 
  parameters, 
  exampleRequest, 
  exampleResponseSuccess, 
  exampleResponseError 
}) => {
  const handleExampleRequest = async () => {
    try {
      const response = await axios.post(url, exampleRequest);
      console.log('Response:', response.data);
    } catch (error:any) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }
  };

  return (
    <section className="endpoint">
      <h2>Endpoint <code>{name}</code></h2>

      <p>{description}</p>

      <h3>URL</h3>
      <pre>{url}</pre>

      <h3>Paramètres de requête</h3>
      <table>
        <thead>
          <tr>
            <th>Paramètre</th>
            <th>Type</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {parameters.map(param => (
            <tr key={param.name}>
              <td><code>{param.name}</code></td>
              <td>{param.type}</td>
              <td>{param.description}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3>Exemple de requête</h3>
      <pre className="example">
        <code>{JSON.stringify(exampleRequest, null, 2)}</code>
      </pre>

      <button onClick={handleExampleRequest}>Tester l'exemple de requête</button>

      <h3>Exemple de réponse (succès)</h3>
      <pre className="example">
        <code>{JSON.stringify(exampleResponseSuccess, null, 2)}</code>
      </pre>

      <h3>Exemple de réponse (erreur)</h3>
      <pre className="example">
        <code>{JSON.stringify(exampleResponseError, null, 2)}</code>
      </pre>
    </section>
  );
};

export default Endpoint;
